import React from 'react'
import SbEditable from "storyblok-react"
import Wave from 'src/utils/Wave'
import Label from 'src/components/Label'
import Heading from 'src/components/Heading'
import Button from 'src/components/Button'
import { BackgroundColour } from 'src/utils/ColourUtilities'
import RichText from 'src/utils/RichText'

const FourByTwoGridOnBrand = ({blok}) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div>
                {(blok.curve_position === 'top' && blok.curve_position !== 'disabled') && <Wave className="fill-blue" size="small" flip/>}
                <div className="bg-blue">
                    <div className="max-w-7xl mx-auto px-6 lg:py-24 py-12 2xl:max-w-screen-2xl">
                        <Label className="text-teal">{blok.label}</Label>
                        <Heading size="h3" className="text-white max-w-2xl mt-4">{blok.title}</Heading>
                        <p className="text-darkblue-400 max-w-3xl lg:text-base text-sm tracking-[-0.01em]">
                            {blok.description}
                        </p>
                        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 xl:gap-20 gap-10 lg:mt-16 mt-12">
                            {blok.items.map((item) => (
                                <div key={item._uid} className="space-y-1 flex flex-col justify-between">
                                    <div className="space-y-1">
                                        {item.icon?.filename &&
                                            <span class="flex h-12 w-12 relative items-center justify-center mb-5">
                                                <span class={`animate-ping absolute inline-flex h-10 w-10 rounded-full opacity-75 ${BackgroundColour(blok.ping_colour)}`}></span>
                                                <span class={`relative inline-flex rounded-full h-12 w-12 ${BackgroundColour(blok.ping_colour)}`}></span>
                                                <img src={item.icon?.filename} alt={item.icon?.alt} className="absolute max-w-[24px]"/>
                                            </span>
                                        }
                                        <h6 className="text-lg font-semibold tracking-[-0.01em] text-white">{item.title}</h6>
                                        <p className="lg:text-base text-sm text-darkblue-400 tracking-[-0.01em] prose prose-p:my-0">
                                            <RichText>{item.description}</RichText>
                                        </p>
                                    </div>
                                    {(item.button_target?.cached_url && item.button_text) &&
                                        <Button to={item.button_target?.cached_url} className="!mt-5 w-fit">{item.button_text}</Button>
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {(blok.curve_position === 'bottom' && blok.curve_position !== 'disabled') && <Wave className="fill-blue" size="small"/>}
            </div>
      </SbEditable>
    )
  };

export default FourByTwoGridOnBrand;
  